export var Fun = {
    MainDataModify: function MainDataModify(data, data2) {
      let newData = [];
      for (let i = 0; i < data["data"].length; i++) {
        let ob = {};
        ob.name = data["label"];
        // ob.date = data["data"][i][0];
        ob.value = data["data"][i][1];
  
        newData.push(ob);
      }
      for (let i = 0; i < data2["data"].length; i++) {
        let ob = {};
        ob.name = data2["label"];
        // ob.date = data2["data"][i][0];
        ob.value = data2["data"][i][1];
  
        newData.push(ob);
      }
      return newData;
    }
  };
  


// WEBPACK FOOTER //
// ./src/components/d3Components/scatterPlot/functions.js